<template>
  <div class="po-imei">
    <div
      class="po-imei-pill"
      :class="{
        'po-imei-pill--locked': locked,
        'po-imei-pill--error': !!error,
      }"
    >
      <i class="mdi mdi-cellphone po-imei-pill-icon"></i>
      <span v-if="locked" class="po-imei-value" :title="value">{{ value }}</span>
      <input
        v-else
        class="po-imei-input"
        :value="value"
        :title="value"
        placeholder="Nhập IMEI mới"
        @input="$emit('input', $event.target.value)"
      />
      <i v-if="locked" class="mdi mdi-lock po-imei-pill-lock"></i>
    </div>
    <div v-if="hint" class="po-hint-success">{{ hint }}</div>
    <div v-if="error" class="po-imei-error">{{ error }}</div>
  </div>
</template>

<script>
export default {
  name: 'ProductionOrderImeiCell',
  props: {
    value: { type: String, default: '' },
    locked: { type: Boolean, default: true },
    hint: { type: String, default: '' },
    error: { type: String, default: '' },
  },
};
</script>
